import products from './products'
import layoutSwitcher from './layoutSwitcher'

const category = {
    products,
    layoutSwitcher,
    async load(id) {
        const results = await window.api.search([{
            indexName: 'new_product_categories',
            query: '',
            params: {
                hitsPerPage: 1,
                page: 0,
                facetFilters: `objectID:${id}`,
            },
        }])
        if (results.length && results[0].nbHits) {
            return results[0].hits[0]
        }
        throw new Error('Unknown category')
    },
    async loadFiltersForCategory(id) {
        const category = await this.load(id)
        return category[window.accuvars.language.iso_code].main_features
    },
}

document.addEventListener('alpine:init', () => {
    window.Alpine.data('category', category)
    window.Alpine.data('categoryProducts', products)
})

export default category
